import React, {useContext} from 'react';
import { LanguageContext } from "../languages/LanguageContext";
import { IoIosArrowRoundBack } from "react-icons/io";
import Header from "../components/Header";
import Footer from "../components/Footer";
import {Link} from "react-router-dom";

const NotFound = () => {
    const { language, translations } = useContext(LanguageContext);
    return (
        <>
        <Header />
        <div className='error-container flex col gap-sm jc-c ai-c max-w'>
            <h2>{translations[language]["404Title"]}</h2>
            <p>{translations[language]["404Subtext"]}</p>
            <Link to='/' className='flex ai-c'>
                <IoIosArrowRoundBack className='icon' />
                {translations[language]["home"]}
            </Link>
        </div>
        <Footer />
        </>
    );
};

export default NotFound;